import { useEffect, useState } from "react";
import { PageHero } from "@/pages/About";
import AnimatedCounter from "@/components/AnimatedCounter";
import ImpactUpdatedCaption from "@/components/ImpactUpdatedCaption";
import { api } from "@/lib/api";

const CATEGORIES = ["Community Impact", "Youth", "Women", "Disability Inclusion", "Health", "Education", "Livelihoods", "Partnerships", "Events"];

export default function Impact() {
    const [stats, setStats] = useState([]);
    useEffect(() => {
        api.get("/public/impact-stats").then(({ data }) => setStats(data.stats || [])).catch(() => {});
    }, []);

    return (
        <div>
            <PageHero title="Our Impact" subtitle="Responsible measurement · Verified outcomes" />

            <section className="gsf-section" data-testid="impact-stats-section">
                <div className="gsf-container">
                    <p className="max-w-3xl text-[color:var(--gsf-body)] leading-relaxed text-lg">
                        Our impact is measured through verified programme records, community engagement and evidence
                        collected in partnership with residents. Figures are updated as data is consolidated.
                    </p>
                    <ImpactUpdatedCaption stats={stats} tone="light" testid="impact-updated" />
                    <div className="mt-8 grid grid-cols-2 md:grid-cols-3 gap-6">
                        {stats.map((s) => (
                            <div key={s.key} className="gsf-card p-8" data-testid={`impact-stat-${s.key}`}>
                                <div className="text-4xl sm:text-5xl font-serif font-bold text-[color:var(--gsf-green-700)]">
                                    <AnimatedCounter value={s.value} prefix={s.prefix} suffix={s.suffix} testId={`impact-${s.key}-val`} />
                                </div>
                                <div className="mt-3 text-sm text-[color:var(--gsf-body)] leading-snug">{s.title || s.label}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="bg-[color:var(--gsf-soft-green)] gsf-section" data-testid="impact-categories">
                <div className="gsf-container">
                    <div className="gsf-eyebrow">Beneficiary Categories</div>
                    <h2 className="mt-3 font-serif text-3xl text-[color:var(--gsf-green-700)] font-bold">Communities we serve</h2>
                    <div className="mt-8 flex flex-wrap gap-3">
                        {CATEGORIES.map((c) => (
                            <span key={c} className="px-4 py-2 rounded-full bg-white border border-[#e2e8de] text-sm text-[color:var(--gsf-green-700)]" data-testid={`impact-cat-${c}`}>
                                {c}
                            </span>
                        ))}
                    </div>
                </div>
            </section>

            <section className="gsf-section" data-testid="impact-reports">
                <div className="gsf-container">
                    <div className="gsf-eyebrow">Reports & Documentation</div>
                    <h2 className="mt-3 font-serif text-3xl text-[color:var(--gsf-green-700)] font-bold">Downloadable reports</h2>
                    <div className="mt-6 gsf-card p-8 max-w-2xl">
                        <p className="text-[color:var(--gsf-body)] leading-relaxed">
                            Impact reports, project updates and independent evaluations will be published here as they
                            are consolidated and approved. To request early access to available documentation, please
                            email{" "}
                            <a className="underline text-[color:var(--gsf-green-700)]" href="mailto:impact@globalseedzim.org">impact@globalseedzim.org</a>.
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
}
